// @ts-check
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { editSuperUserAction } from '../redux/actions/client-actions';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(2)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

function EditSuperUserFormComponent(props) {
  const classes = useStyles();

  const { error, loading } = useSelector((state) => state.loading);

  const { values, errors, touched, handleSubmit, handleChange, handleBlur, handleClose } = props;

  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <TextField
        {...formikProps('firstname')}
        id="outlined-full-width"
        label="First Name"
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <TextField
        {...formikProps('lastname')}
        id="outlined-full-width"
        label="Last Name"
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <TextField
        {...formikProps('email')}
        id="outlined-full-width"
        label="Email"
        type="text"
        variant="outlined"
        fullWidth={true}
        disabled
      />

      <TextField
        {...formikProps('mobile_no')}
        id="outlined-full-width"
        label="Phone no."
        type="text"
        variant="outlined"
        fullWidth={true}
        disabled
      />

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
            >
              Save Changes
            </Button>

            <Button
              className={classes.margin}
              variant="outlined"
              size="large"
              color="secondary"
              fullWidth={true}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}

        {error && (
          <div>
            <span className={classes.errorText}>{error.message}</span>
          </div>
        )}
      </div>
    </form>
  );
}

const validationSchema = Yup.object({
  firstname: Yup.string('Enter first name').required('First name is required'),
  lastname: Yup.string('Enter last name').required('Last name is required')
});

export function EditSuperUserForm({ client, handleClose }) {
  const dispatch = useDispatch();
  const user = client.super_user;

  const values = {
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email,
    mobile_no: user.mobile_no
  };

  const submit = (data) => {
    const props = { handleClose };
    dispatch(editSuperUserAction(client.id, user.id, data.firstname, data.lastname, props));
  };

  return (
    <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
      {(props) => <EditSuperUserFormComponent {...props} handleClose={handleClose} />}
    </Formik>
  );
}
